<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <!-- 사업장 -->
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-text
            label="동력기계명"
            name="powerMachineName"
            v-model="searchParam.powerMachineName">
          </c-text>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-text
            label="동력기계번호"
            name="psiPowerEquipmentNo"
            v-model="searchParam.psiPowerEquipmentNo">
          </c-text>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-line
            label="관련라인"
            multiple="single"
            name="processCd"
            v-model="searchParam.processCd">
          </c-line>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            :isFirstValue="false"
            label="관리부서"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-table
          ref="powerMachine"
          title="설비 및 기계 목록"
          tableId="powerMachine"
          :columns="grid.columns"
          :gridHeight="grid.height"
          :data="grid.data"
          rowKey="psiPowerEquipmentId"
          :expandAll="true"
          @linkClick="linkClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <c-btn v-if="editable" label="등록" icon="add" @btnClicked="equipmentPopup" />
              <c-btn label="검색" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'power-machine',
  data() {
    return {
      grid: {
        columns: [
          {
            fix: true,
            name: 'plantName',
            field: 'plantName',
            label: '사업장',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            fix: true,
            name: 'revisionNum',
            field: 'revisionNum',
            label: 'Rev.',
            align: 'center',
            style: 'width:50px',
            sortable: true,
          },
          {
            fix: true,
            name: 'lineCd',
            field: 'lineCd',
            label: 'LINE',
            align: 'center',
            style: 'width:70px',
            sortable: true,
          },
          // {
          //   fix: true,
          //   name: 'location',
          //   field: 'location',
          //   label: '장소',
          //   align: 'center',
          //   style: 'width:80px',
          //   sortable: true,
          // },
          {
            fix: true,
            name: 'psiPowerEquipmentNo',
            field: 'psiPowerEquipmentNo',
            label: '구분기호',
            align: 'center',
            style: 'width:100px',
            sortable: true,
          },
          {
            fix: true,
            name: 'powerMachineName',
            field: 'powerMachineName',
            label: '동력기계명',
            align: 'left',
            type: 'link',
            style: 'width:200px',
            sortable: true,
          },
          {
            label: '연결설비명',
            align: 'center',
            child: [
              {
                name: 'specInfo',
                field: 'specInfo',
                label: '인입측',
                align: 'center',
                style: 'width:180px',
                sortable: true,
              },
              {
                name: 'matQuality',
                field: 'matQuality',
                label: '토출측',
                align: 'center',
                style: 'width:180px',
                sortable: true,
              },
            ]
          },
          {
            name: 'motorVol',
            field: 'motorVol',
            label: '취급물질',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'noiseValue',
            field: 'noiseValue',
            label: '토출압력<br>(MPa)',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'protectType',
            field: 'protectType',
            label: '토출온도<br>(℃)',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'powerCol1',
            field: 'powerCol1',
            label: '토출유량<br>(Kg/hr)',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'powerCol2',
            field: 'powerCol2',
            label: '전동기용량<br>(kW)',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'powerCol3',
            field: 'powerCol3',
            label: '주요재질',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'remarks',
            field: 'remarks',
            label: '비고',
            align: 'center',
            style: 'width:200px',
            sortable: true,
          },
        ],
        data: [],
      },
      searchParam: {
        plantCd: '',
        powerMachineName: '',
        processCd: '',
        deptCd: '',
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // api scope
      this.listUrl = selectConfig.psi.pfi.power.list.url;
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    linkClick(row) {
      this.equipmentPopup(row);
    },
    equipmentPopup(result) {
      this.popupOptions.target = () => import(`${"./powerMachineDetail.vue"}`);
      this.popupOptions.title = '동력기계 상세';
      this.popupOptions.param = {
        psiPowerEquipmentId: result ? result.psiPowerEquipmentId : '',
      };
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
